// ADR 16.10.26f §1 — which guide a learner sees, from the UA alone.
//
// Pure, in `installAffordance.ts`' predicate style, and it classifies all
// eight variants of roadmap 16.10.26c D2 now, so G4 (16.10.26g) only adds
// tracks. It reads `platformOf` and `iosBrowserOf` and never changes them:
// `mac_safari` already carries the Safari 26 floor, and a touch `Macintosh`
// UA (iPadOS's desktop mode) already arrives as `ios`, so the `Macintosh`
// test below is reachable and a real Mac never reaches it. iPad Chrome and
// Edge send a Safari-shaped desktop UA and read as `ipad_safari` — roadmap
// D8's recorded mismatch.
//
// Must not import the wasm facade: it is in 25.9.26f's boot graph.

import { iosBrowserOf, majorOf } from '../installAffordance'

export type GuideVariant =
  | 'iphone_safari_26'
  | 'iphone_safari_classic'
  | 'ipad_safari'
  | 'ios_chrome'
  | 'ios_edge'
  | 'ios_firefox'
  | 'ios_other'
  | 'mac_safari'

/** The first iPhone Safari whose default (Compact) layout puts Share behind ⋯. */
const SAFARI_26_MAJOR = 26

const OTHER_BROWSERS = { chrome: 'ios_chrome', edge: 'ios_edge', firefox: 'ios_firefox', other: 'ios_other' } as const

function isIpad(userAgent: string, maxTouchPoints: number): boolean {
  return /iPad/.test(userAgent) || (/Macintosh/.test(userAgent) && maxTouchPoints > 1)
}

export function guideVariantOf(platform: 'ios' | 'mac_safari', userAgent: string, maxTouchPoints: number): GuideVariant {
  if (platform === 'mac_safari') return 'mac_safari'
  const browser = iosBrowserOf(userAgent)
  if (browser !== 'safari') return OTHER_BROWSERS[browser]
  if (isIpad(userAgent, maxTouchPoints)) return 'ipad_safari'
  return majorOf(userAgent, 'Version') >= SAFARI_26_MAJOR ? 'iphone_safari_26' : 'iphone_safari_classic'
}
